webpackJsonp([1],{

/***/ 294:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 307:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_visszahivas_keres__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__visszahivas_keres_pug__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__visszahivas_keres_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__visszahivas_keres_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__visszahivas_keres_form_visszahivas_keres_form__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid_v1__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid_v1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_uuid_v1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_timers__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_timers__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var MODULE_NAME = 'visszahivasKeres';

var KapcsolatController = function () {
	KapcsolatController.$inject = ['visszahivasKeresService', '$rootScope', 'vcRecaptchaService', '$element'];

	function KapcsolatController(visszahivasKeresService, $rootScope, vcRecaptchaService, $element) {
		'ngInject';

		_classCallCheck(this, KapcsolatController);

		this.visszahivasKeresService = visszahivasKeresService;
		this.uuid = __WEBPACK_IMPORTED_MODULE_3_uuid_v1___default.a;
		this.rootScope = $rootScope;
		this.vcRecaptchaService = vcRecaptchaService;
		this.$element = $element;
	}

	KapcsolatController.prototype.$onInit = function $onInit() {
		var _this = this;

		this.showForm = this.type == 'contactBar' ? false : true;
		this.visszahivasKeresService.getVisszahivasKeresInit().then(function (response) {
			_this.getUuid(function (captchaId) {
				_this.initData = response.data;
				_this.initData.captchaId = captchaId;
			});
		}, function (error) {
			_this.rootScope.$broadcast('serverError');
			_this.error = error;
		});
	};

	KapcsolatController.prototype.sendForm = function sendForm(model) {
		var _this2 = this;

		this.model = model;
		this.visszahivasKeresService.sendVisszahivas(this.model).then(function (response) {
			if (response.status == 200) {
				_this2.success = true;
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_timers__["setTimeout"])(function () {
					_this2.addFocusToElement('app-visszahivas-keres__success-text');
				});
			}
		}, function (error) {
			_this2.formError = error;
			_this2.error = true;
		});
	};

	KapcsolatController.prototype.getUuid = function getUuid(callback) {
		callback(this.uuid());
	};

	KapcsolatController.prototype.addClassForResponsiveView = function addClassForResponsiveView() {
		var documentElement = angular.element(document);
		var bodyElemenet = documentElement.find('body');
		if (this.showForm) {
			bodyElemenet.removeClass("vhk-open");
		} else {
			bodyElemenet.addClass("vhk-open");
		}
	};

	KapcsolatController.prototype.showOrHideForm = function showOrHideForm(event) {
		var _this3 = this;

		if (event) {
			event.preventDefault();
		}
		this.addClassForResponsiveView();
		this.success = false;
		this.showForm = !this.showForm;
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_timers__["setTimeout"])(function () {
			_this3.addFocusToElement('onfocus');
		});
	};

	KapcsolatController.prototype.addFocusToElement = function addFocusToElement(elemClass) {
		if (this.$element[0].getElementsByClassName(elemClass).length) {
			this.$element[0].getElementsByClassName(elemClass)[0].focus();
		}
	};

	return KapcsolatController;
}();

/* unused harmony default export */ var _unused_webpack_default_export = (angular.module(MODULE_NAME, [__WEBPACK_IMPORTED_MODULE_0__services_visszahivas_keres__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__visszahivas_keres_form_visszahivas_keres_form__["a" /* default */]]).component(MODULE_NAME, {
	controller: KapcsolatController,
	template: __WEBPACK_IMPORTED_MODULE_1__visszahivas_keres_pug___default()(),
	bindings: {
		id: '@',
		type: '@',
		documentUrl: '@'
	}
}).name);

/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(37);
module.exports = 'vcRecaptcha';


/***/ }),

/***/ 37:
/***/ (function(module, exports) {

/**
 * @license angular-recaptcha build:2018-05-09
 * https://github.com/vividcortex/angular-recaptcha
 * Copyright (c) 2018 VividCortex
**/

/*global angular, Recaptcha */
(function (ng) {
    'use strict';

    ng.module('vcRecaptcha', []);

}(angular));

/*global angular */
(function (ng) {
    'use strict';

    function throwNoKeyException() {
        throw new Error('You need to set the "key" attribute to your public reCaptcha key. If you don\'t have a key, please get one from https://www.google.com/recaptcha/admin/create');
    }

    var app = ng.module('vcRecaptcha');

    /**
     * An angular service to wrap the reCaptcha API
     */
    app.provider('vcRecaptchaService', function(){
        var provider = this;
        var config = {};
        provider.onLoadFunctionName = 'vcRecaptchaApiLoaded';

        /**
         * Sets the reCaptcha configuration values which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param defaults  object which overrides the current defaults object.
         */
        provider.setDefaults = function(defaults){
            ng.copy(defaults, config);
        };

        /**
         * Sets the reCaptcha key which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param siteKey  the reCaptcha public key (refer to the README file if you don't know what this is).
         */
        provider.setSiteKey = function(siteKey){
            config.key = siteKey;
        };

        /**
         * Sets the reCaptcha theme which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param theme  The reCaptcha theme.
         */
        provider.setTheme = function(theme){
            config.theme = theme;
        };

        /**
         * Sets the reCaptcha stoken which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param stoken  The reCaptcha stoken.
         */
        provider.setStoken = function(stoken){
            config.stoken = stoken;
        };

        /**
         * Sets the reCaptcha size which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param size  The reCaptcha size.
         */
        provider.setSize = function(size){
            config.size = size;
        };

        /**
         * Sets the reCaptcha type which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param type  The reCaptcha type.
         */
        provider.setType = function(type){
            config.type = type;
        };

        /**
         * Sets the reCaptcha language which will be used by default is not specified in a specific directive instance.
         *
         * @param lang  The reCaptcha language.
         */
        provider.setLang = function(lang){
            config.lang = lang;
        };

        /**
         * Sets the reCaptcha badge position which will be used by default if not specified in a specific directive instance.
         *
         * @param badge  The reCaptcha badge position.
         */
        provider.setBadge = function(badge){
            config.badge = badge;
        };

        /**
         * Sets the reCaptcha configuration values which will be used by default is not specified in a specific directive instance.
         *
         * @since 2.5.0
         * @param onLoadFunctionName  string name which overrides the name of the onload function. Should match what is in the recaptcha script querystring onload value.
         */
        provider.setOnLoadFunctionName = function(onLoadFunctionName){
            provider.onLoadFunctionName = onLoadFunctionName;
        };

        provider.$get = ['$rootScope','$window', '$q', '$document', '$interval', function ($rootScope, $window, $q, $document, $interval) {
            var deferred = $q.defer(), promise = deferred.promise, instances = {}, recaptcha;

            $window.vcRecaptchaApiLoadedCallback = $window.vcRecaptchaApiLoadedCallback || [];

            var callback = function () {
                recaptcha = $window.grecaptcha;

                deferred.resolve(recaptcha);
            };

            $window.vcRecaptchaApiLoadedCallback.push(callback);

            $window[provider.onLoadFunctionName] = function () {
                $window.vcRecaptchaApiLoadedCallback.forEach(function(callback) {
                    callback();
                });
            };


            function getRecaptcha() {
                if (!!recaptcha) {
                    return $q.when(recaptcha);
                }

                return promise;
            }

            function validateRecaptchaInstance() {
                if (!recaptcha) {
                    throw new Error('reCaptcha has not been loaded yet.');
                }
            }

            function isRenderFunctionAvailable() {
                return ng.isFunction(($window.grecaptcha || {}).render);
            }


            // Check if grecaptcha.render is not defined already.
            if (isRenderFunctionAvailable()) {
                callback();
            } else if ($window.document.querySelector('script[src^="https://www.google.com/recaptcha/api.js"]')) {
                // wait for script to be loaded.
                var intervalWait = $interval(function() {
                    if (isRenderFunctionAvailable()) {
                        $interval.cancel(intervalWait);
                        callback();
                    }
                }, 25);
            } else {
                // Generate link on demand
                var script = $window.document.createElement('script');
                script.async = true;
                script.defer = true;
                script.src = 'https://www.google.com/recaptcha/api.js?onload='+provider.onLoadFunctionName+'&render=explicit';
                $document.find('body')[0].appendChild(script);
            }

            return {

                /**
                 * Creates a new reCaptcha object
                 *
                 * @param elm  the DOM element where to put the captcha
                 * @param conf the captcha object configuration
                 * @throws NoKeyException    if no key is provided in the provider config or the directive instance (via attribute)
                 */
                create: function (elm, conf) {

                    conf.sitekey = conf.key || config.key;
                    conf.theme = conf.theme || config.theme;
                    conf.stoken = conf.stoken || config.stoken;
                    conf.size = conf.size || config.size;
                    conf.type = conf.type || config.type;
                    conf.hl = conf.lang || config.lang;
                    conf.badge = conf.badge || config.badge;

                    if (!conf.sitekey) {
                        throwNoKeyException();
                    }
                    return getRecaptcha().then(function (recaptcha) {
                        var widgetId = recaptcha.render(elm, conf);
                        instances[widgetId] = elm;
                        return widgetId;
                    });
                },

                /**
                 * Reloads the reCaptcha
                 */
                reload: function (widgetId) {
                    validateRecaptchaInstance();

                    recaptcha.reset(widgetId);

                    // Let everyone know this widget has been reset.
                    $rootScope.$broadcast('reCaptchaReset', widgetId);
                },

                /**
                 * Executes the reCaptcha
                 */
                execute: function (widgetId) {
                    validateRecaptchaInstance();

                    recaptcha.execute(widgetId);
                },

                /**
                 * Get/Set reCaptcha language
                 */
                useLang: function (widgetId, lang) {
                    var instance = instances[widgetId];

                    if (instance) {
                        var iframe = instance.querySelector('iframe');
                        if (lang) {
                            // Setter
                            if (iframe && iframe.src) {
                                var s = iframe.src;
                                if (/[?&]hl=/.test(s)) {
                                    s = s.replace(/([?&]hl=)\w+/, '$1' + lang);
                                } else {
                                    s += ((s.indexOf('?') === -1) ? '?' : '&') + 'hl=' + lang;
                                }

                                iframe.src = s;
                            }
                        } else {
                            // Getter
                            if (iframe && iframe.src && /[?&]hl=\w+/.test(iframe.src)) {
                                return iframe.src.replace(/.+[?&]hl=(\w+)([^\w].+)?/, '$1');
                            } else {
                                return null;
                            }
                        }
                    } else {
                        throw new Error('reCaptcha Widget ID not exists', widgetId);
                    }
                },

                /**
                 * Gets the response from the reCaptcha widget.
                 *
                 * @see https://developers.google.com/recaptcha/docs/display#js_api
                 *
                 * @returns {String}
                 */
                getResponse: function (widgetId) {
                    validateRecaptchaInstance();

                    return recaptcha.getResponse(widgetId);
                },

                /**
                 * Gets reCaptcha instance and configuration
                 */
                getInstance: function (widgetId) {
                    return instances[widgetId];
                },

                /**
                 * Destroy reCaptcha instance.
                 */
                destroy: function (widgetId) {
                    delete instances[widgetId];
                }
            };

        }];
    });

}(angular));

/*global angular, Recaptcha */
(function (ng) {
    'use strict';

    var app = ng.module('vcRecaptcha');

    app.directive('vcRecaptcha', ['$document', '$timeout', 'vcRecaptchaService', function ($document, $timeout, vcRecaptcha) {

        return {
            restrict: 'A',
            require: "?^^form",
            scope: {
                response: '=?ngModel',
                key: '=?',
                stoken: '=?',
                theme: '=?',
                size: '=?',
                type: '=?',
                lang: '=?',
                badge: '=?',
                tabindex: '=?',
                required: '=?',
                onCreate: '&',
                onSuccess: '&',
                onExpire: '&'
            },
            link: function (scope, elm, attrs, ctrl) {
                scope.widgetId = null;

                if(ctrl && ng.isDefined(attrs.required)){
                    scope.$watch('required', validate);
                }

                var removeCreationListener = scope.$watch('key', function (key) {
                    var callback = function (gRecaptchaResponse) {
                        // Safe $apply
                        $timeout(function () {
                            scope.response = gRecaptchaResponse;
                            validate();

                            // Notify about the response availability
                            scope.onSuccess({response: gRecaptchaResponse, widgetId: scope.widgetId});
                        });
                    };

                    vcRecaptcha.create(elm[0], {

                        callback: callback,
                        key: key,
                        stoken: scope.stoken || attrs.stoken || null,
                        theme: scope.theme || attrs.theme || null,
                        type: scope.type || attrs.type || null,
                        lang: scope.lang || attrs.lang || null,
                        tabindex: scope.tabindex || attrs.tabindex || null,
                        size: scope.size || attrs.size || null,
                        badge: scope.badge || attrs.badge || null,
                        'expired-callback': expired

                    }).then(function (widgetId) {
                        // The widget has been created
                        validate();
                        scope.widgetId = widgetId;
                        scope.onCreate({widgetId: widgetId});

                        scope.$on('$destroy', destroy);

                        scope.$on('reCaptchaReset', function(event, resetWidgetId){
                          if(ng.isUndefined(resetWidgetId) || widgetId === resetWidgetId){
                            scope.response = "";
                            validate();
                          }
                        })

                    });

                    // Remove this listener to avoid creating the widget more than once.
                    removeCreationListener();
                });

                function destroy() {
                  if (ctrl) {
                    // reset the validity of the form if we were removed
                    ctrl.$setValidity('recaptcha', null);
                  }

                  cleanup();
                }

                function expired(){
                    // Safe $apply
                    $timeout(function () {
                        scope.response = "";
                        validate();

                        // Notify about the response availability
                        scope.onExpire({ widgetId: scope.widgetId });
                    });
                }

                function validate(){
                    if(ctrl){
                        ctrl.$setValidity('recaptcha', scope.required === false ? null : Boolean(scope.response));
                    }
                }

                function cleanup(){
                  vcRecaptcha.destroy(scope.widgetId);

                  // removes elements reCaptcha added.
                  ng.element($document[0].querySelectorAll('.pls-container')).parent().remove();
                }
            }
        };
    }]);

}(angular));


/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(60);
var bytesToUuid = __webpack_require__(59);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = rng();
    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [
        seedBytes[0] | 0x01,
        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
      ];
    }
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),

/***/ 557:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MODULE_NAME = 'visszahivasKeresService';

var VisszahivasKeresService = function () {
	VisszahivasKeresService.$inject = ['$http'];

	function VisszahivasKeresService($http) {
		'ngInject';

		_classCallCheck(this, VisszahivasKeresService);

		this.$http = $http;
		this.apiRoot = '/api/';
	}

	VisszahivasKeresService.prototype.getVisszahivasKeresInit = function getVisszahivasKeresInit() {
		return this.$http.get(this.apiRoot + 'visszahivas/init');
	};

	VisszahivasKeresService.prototype.sendVisszahivas = function sendVisszahivas(emailObject) {
		var objectToPost = Object.assign({}, emailObject);
		var captchaValue = objectToPost.captchaValue;
		delete objectToPost.captchaValue;
		return this.$http({
			url: this.apiRoot + 'visszahivas/',
			method: 'POST',
			headers: {
				'captcha': captchaValue
			},
			data: objectToPost
		});
	};

	return VisszahivasKeresService;
}();

/* harmony default export */ __webpack_exports__["a"] = (angular.module(MODULE_NAME, []).service('visszahivasKeresService', VisszahivasKeresService).name);

/***/ }),

/***/ 563:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__visszahivas_keres_visszahivas_keres_form_visszahivas_keres_form_pcss__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__visszahivas_keres_visszahivas_keres_form_visszahivas_keres_form_pcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__visszahivas_keres_visszahivas_keres_form_visszahivas_keres_form_pcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__visszahivas_keres_visszahivas_keres_visszahivas_keres__ = __webpack_require__(307);



/***/ }),

/***/ 564:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__visszahivas_keres_form_pug__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__visszahivas_keres_form_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__visszahivas_keres_form_pug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_constants_consts__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid_v1__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid_v1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_uuid_v1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_angular_recaptcha__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_angular_recaptcha___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_angular_recaptcha__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils_refresh_selects__ = __webpack_require__(58);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var MODULE_NAME = 'visszahivasKeresForm';

var VisszahivasKeresFormController = function (_RefreshSelects) {
	VisszahivasKeresFormController.$inject = ['$rootScope', 'vcRecaptchaService', '$element'];

	_inherits(VisszahivasKeresFormController, _RefreshSelects);

	function VisszahivasKeresFormController($rootScope, vcRecaptchaService, $element) {
		'ngInject';

		_classCallCheck(this, VisszahivasKeresFormController);

		var _this = _possibleConstructorReturn(this, _RefreshSelects.call(this, $element));

		_this.rootScope = $rootScope;
		_this.uuid = __WEBPACK_IMPORTED_MODULE_2_uuid_v1___default.a;
		_this.vcRecaptchaService = vcRecaptchaService;
		_this.$element = $element[0];
		return _this;
	}

	VisszahivasKeresFormController.prototype.$onInit = function $onInit() {
		this.model = {};
		this.adatvedelmiIsChecked = false;
		this.error = false;
		this.patterns = {
			email: __WEBPACK_IMPORTED_MODULE_1__common_constants_consts__["a" /* EMAIL_PATTERN */],
			phone: __WEBPACK_IMPORTED_MODULE_1__common_constants_consts__["b" /* PHONE_PATTERN */],
			simpleText: __WEBPACK_IMPORTED_MODULE_1__common_constants_consts__["c" /* SIMPLE_TEXT_PATTERN */]
		};
	};

	VisszahivasKeresFormController.prototype.$onChanges = function $onChanges(changeObject) {
		var _this2 = this;

		if (changeObject.initData && changeObject.initData.currentValue) {
			this.targyak = angular.copy(this.initData.targyak);
			this.visszahivasIdok = angular.copy(this.initData.visszahivasIdok);
			this.captchaUrl = angular.copy(this.initData.captchaUrl);
			this.model.captchaId = angular.copy(this.initData.captchaId);
			this.rerenderNativeSelects();
		}
		if (changeObject.errors && changeObject.errors.currentValue) {
			this.resetCaptcha();
			this.serverError = angular.copy(this.errors.data.errors);
			this.serverError.forEach(function (item) {
				if (item.field == 'captcha' && item.message == 'invalid') {
					_this2.model.captchaValue = '';
					_this2.visszahivasKeresForm.captcha.$error.serverError = true;
				} else {
					_this2.rootScope.$broadcast('serverError');
				}
			});
		}
		if (changeObject.success && changeObject.success.currentValue) {
			if (this.success) {
				this.resetForm();
			}
		}
	};

	VisszahivasKeresFormController.prototype.resetForm = function resetForm() {
		this.visszahivasKeresForm.$setPristine();
		this.visszahivasKeresForm.$setUntouched();
		this.model = angular.copy({});
		this.adatvedelmiIsChecked = false;
		this.model.captchaId = this.uuid();
		this.resetCaptcha();
	};

	VisszahivasKeresFormController.prototype.postVisszahivasKeresForm = function postVisszahivasKeresForm() {
		if (this.visszahivasKeresForm.$valid) {
			this.postForm({
				data: this.model
			});
		}
	};

	VisszahivasKeresFormController.prototype.getCaptcha = function getCaptcha() {
		var now = new Date().getTime();
		this.captchaImage = this.captchaUrl.replace('{id}', this.model.captchaId + '?' + now);
	};

	VisszahivasKeresFormController.prototype.changeOiselect = function changeOiselect(subjectId) {
		this.model.subjectId = subjectId;
	};

	VisszahivasKeresFormController.prototype.resetCaptcha = function resetCaptcha() {
		this.vcRecaptchaService.reload();
	};

	VisszahivasKeresFormController.prototype.changeNativeSelect = function changeNativeSelect(subjectId) {
		for (var _iterator = this.restTargyak, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
			var _ref;

			if (_isArray) {
				if (_i >= _iterator.length) break;
				_ref = _iterator[_i++];
			} else {
				_i = _iterator.next();
				if (_i.done) break;
				_ref = _i.value;
			}

			var restTargy = _ref;

			if (restTargy.subjectId == subjectId) {
				this.oiSelectModel = restTargy;
			}
		}
	};

	return VisszahivasKeresFormController;
}(__WEBPACK_IMPORTED_MODULE_4__common_utils_refresh_selects__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (angular.module(MODULE_NAME, [__WEBPACK_IMPORTED_MODULE_3_angular_recaptcha___default.a]).component(MODULE_NAME, {
	controller: VisszahivasKeresFormController,
	template: __WEBPACK_IMPORTED_MODULE_0__visszahivas_keres_form_pug___default()(),
	bindings: {
		id: '<',
		initData: '<',
		errors: '<',
		postForm: '&',
		success: '<',
		documentUrl: '@'
	}
}).name);

/***/ }),

/***/ 58:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__native_accessible_select_native_accessible_select__ = __webpack_require__(53);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var RefreshSelects = function () {
	RefreshSelects.$inject = ['$element'];

	function RefreshSelects($element) {
		'ngInject';

		_classCallCheck(this, RefreshSelects);

		this.rootElementForSelects = $element[0];
	}

	RefreshSelects.prototype.rerenderNativeSelects = function rerenderNativeSelects() {
		var _this = this;

		setTimeout(function () {
			var designSelects = Array.from(_this.rootElementForSelects.querySelectorAll('.accessible-select-wrapper'));
			designSelects.forEach(function (item) {
				item.parentNode.removeChild(item);
			});

			var selects = Array.from(_this.rootElementForSelects.querySelectorAll('select'));
			selects.forEach(function (item) {
				item.removeAttribute('has-accessible-select');
				setTimeout(function () {
					new __WEBPACK_IMPORTED_MODULE_0__native_accessible_select_native_accessible_select__["a" /* default */]({ element: item });
				}, 0);
			});
		}, 0);
	};

	return RefreshSelects;
}();

/* harmony default export */ __webpack_exports__["a"] = (RefreshSelects);

/***/ }),

/***/ 59:
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([bth[buf[i++]], bth[buf[i++]], 
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]]]).join('');
}

module.exports = bytesToUuid;


/***/ }),

/***/ 591:
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 60:
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),

/***/ 616:
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(2);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cform class=\"visszahivas-keres-form\" name=\"$ctrl.visszahivasKeresForm\" novalidate\u003E\u003Cdiv class=\"row form__row\" aria-hidden=\"true\"\u003E\u003Cdiv class=\"col-sm-8 col-sm-offset-4\"\u003E\u003Csmall class=\"app-kapcsolat__disclaimer\"\u003E*: Kötelezően kitöltendő mezők\u003C\u002Fsmall\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form__row\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Clabel class=\"label label--right\" for=\"{{$ctrl.id}}_visszahivas-keres-form__nev\"\u003ENév\u003Cspan aria-hidden=\"true\"\u003E*:\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cinput class=\"form-input onfocus\" id=\"{{$ctrl.id}}_visszahivas-keres-form__nev\" type=\"text\" name=\"nev\" ng-model=\"$ctrl.model.name\" maxlength=\"40\" ng-pattern=\"$ctrl.patterns.simpleText\" required aria-describedby=\"{{$ctrl.id}}_vhkNameError\"\u003E\u003Cinput-error id=\"{{$ctrl.id}}_vhkNameError\" form=\"$ctrl.visszahivasKeresForm\" input-name=\"nev\" message-required=\"Kérjük adja meg a nevét!\" message-pattern=\"Kérjük helyesen adja meg a nevét!\"\u003E\u003C\u002Finput-error\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form__row\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Clabel class=\"label label--right\" id=\"{{$ctrl.id}}_visszahivas-keres-form__targy-label\" for=\"{{$ctrl.id}}_visszahivas-keres-form__targy\"\u003ETárgy\u003Cspan aria-hidden=\"true\"\u003E*:\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cselect class=\"select\" id=\"{{$ctrl.id}}_visszahivas-keres-form__targy\" name=\"targy\" ng-model=\"$ctrl.model.subject\" required\u003E\u003Coption value=\"\" disabled selected\u003EKérjük válasszon!\u003C\u002Foption\u003E\u003Coption value=\"{{ targy }}\" ng-repeat=\"targy in $ctrl.targyak track by $index\"\u003E{{ targy }}\u003C\u002Foption\u003E\u003C\u002Fselect\u003E\u003Cinput-error id=\"{{$ctrl.id}}_vhkSubjectError\" form=\"$ctrl.visszahivasKeresForm\" input-name=\"targy\" message-required=\"Kérjük válasszon tárgyat!\"\u003E\u003C\u002Finput-error\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form__row\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Clabel class=\"label label--right\" for=\"{{$ctrl.id}}_visszahivas-keres-form__telefon\"\u003ETelefonszám\u003Cspan aria-hidden=\"true\"\u003E*:\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cinput class=\"form-input\" id=\"{{$ctrl.id}}_visszahivas-keres-form__telefon\" type=\"tel\" name=\"telefon\" ng-model=\"$ctrl.model.phone\" maxlength=\"25\" ng-pattern=\"$ctrl.patterns.phone\" required aria-describedby=\"{{$ctrl.id}}_vhkPhoneError\"\u003E\u003Cinput-error id=\"{{$ctrl.id}}_vhkPhoneError\" form=\"$ctrl.visszahivasKeresForm\" input-name=\"telefon\" message-pattern=\"Kérjük helyesen adja meg a telefonszámot!\" message-required=\"Kérjük adja meg a telefonszámát!\"\u003E\u003C\u002Finput-error\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form__row\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Clabel class=\"label label--right\" for=\"{{$ctrl.id}}_visszahivas-keres-form__email\"\u003EE-mail cím:\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cinput class=\"form-input\" id=\"{{$ctrl.id}}_visszahivas-keres-form__email\" type=\"email\" name=\"email\" ng-model=\"$ctrl.model.email\" maxlength=\"40\" ng-pattern=\"$ctrl.patterns.email\" ng-model-options=\"{updateOn: 'blur'}\" aria-describedby=\"{{$ctrl.id}}_vhkEmailError\"\u003E\u003Cinput-error id=\"{{$ctrl.id}}_vhkEmailError\" form=\"$ctrl.visszahivasKeresForm\" input-name=\"email\" message-pattern=\"Hibásan adta meg az e-mail címet, kérjük pontosítsa az adatokat!\"\u003E\u003C\u002Finput-error\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form__row\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Clabel class=\"label label--right\" id=\"{{$ctrl.id}}_visszahivas-keres-form__idopont-label\" for=\"{{$ctrl.id}}_visszahivas-keres-form__idopont\"\u003EVisszahívás időpontja\u003Cspan aria-hidden=\"true\"\u003E*:\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cinput-error id=\"{{$ctrl.id}}_vhkCallbackError\" form=\"$ctrl.visszahivasKeresForm\" input-name=\"oiMegye\" message-required=\"Kérjük válasszon időpontot!\"\u003E\u003C\u002Finput-error\u003E\u003Cselect class=\"select\" id=\"{{$ctrl.id}}_visszahivas-keres-form__idopont\" name=\"idopont\" ng-model=\"$ctrl.model.time\" required inputerrorId=\"{{$ctrl.id}}_vhkCallbackError\"\u003E\u003Coption value=\"\" disabled selected role=\"option\"\u003EKérjük válasszon!\u003C\u002Foption\u003E\u003Coption value=\"{{ idopont }}\" ng-repeat=\"idopont in $ctrl.visszahivasIdok track by $index\" role=\"option\"\u003E{{ idopont }}\u003C\u002Foption\u003E\u003C\u002Fselect\u003E\u003Cinput-error id=\"{{$ctrl.id}}_vhkCallbackError\" form=\"$ctrl.visszahivasKeresForm\" input-name=\"idopont\" message-required=\"Kérjük válasszon időpontot!\"\u003E\u003C\u002Finput-error\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row form__row captcha__row\"\u003E\u003Cdiv class=\"col-sm-4\"\u003E\u003Clabel class=\"label label--right\" for=\"visszahivas-keres-form__captcha\"\u003EEllenőrzés\u003Cspan aria-hidden=\"true\"\u003E*:\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-8\"\u003E\u003Cdiv class=\"captcha\"\u003E\u003Cdiv vc-recaptcha key=\"'6LdfJB8TAAAAAPGueZFYId4-pMm-6RvQ2Tz6ZmyO'\" ng-model=\"$ctrl.model.captchaValue\" name=\"captcha\" required on-expire=\"this.resetCaptcha()\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cinput-error id=\"{{$ctrl.id}}_vhkCaptchaError\" form=\"$ctrl.visszahivasKeresForm\" input-name=\"captcha\" message-required=\"Hibásan adta meg a képen szereplő szöveget, kérjük pontosítsa az adatokat!\" message-pattern=\"Kérjük helyesen adja meg a képen szereplő szöveget!\" message-server-error=\"Hibásan adta meg a képen szereplő szöveget, kérjük pontosítsa az adatokat!\"\u003E\u003C\u002Finput-error\u003E\u003Cdiv class=\"checkbox__item\"\u003E\u003Cinput id=\"{{$ctrl.id}}_visszahivas-keres-form__adatvedelmi\" type=\"checkbox\" name=\"adatvedelmi\" ng-model=\"$ctrl.adatvedelmiIsChecked\"\u003E\u003Clabel class=\"checkbox\" for=\"{{$ctrl.id}}_visszahivas-keres-form__adatvedelmi\"\u003EKijelentem, hogy az \u003Ca href=\"https:\u002F\u002Fwww.otpnyugdij.hu\u002Fstatic\u002Fotpnyugdij\u002Fdownload\u002Fonyp_adatkezelesi_tajekoztato.pdf\" target=\"_blank\" rel=\"noopener noreferrer\"\u003EAdatkezelési tájékoztató\u003C\u002Fa\u003E tartalmát megismertem és tudomásul vettem annak III. fejezetében leírtakat.\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cbutton class=\"button\" type=\"submit\" ng-disabled=\"$ctrl.visszahivasKeresForm.$invalid || !$ctrl.adatvedelmiIsChecked\" ng-click=\"$ctrl.postVisszahivasKeresForm()\"\u003EVisszahívást kérek\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ 617:
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(2);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"app-visszahivas-keres\"\u003E\u003Cdiv class=\"app-visszahivas-keres__header\" ng-if=\"$ctrl.showForm\"\u003E\u003Ch3 class=\"app-visszahivas-keres__header-subtitle\"\u003EKérjen visszahívást!\u003Cspan class=\"app-visszahivas-keres__header-icon onyp-arrow_vhk\" aria-hidden=\"true\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fh3\u003E\u003Ca class=\"app-visszahivas-keres__btn-close\" href=\"#\" ng-click=\"$ctrl.showOrHideForm($event)\" role=\"button\" title=\"Visszahíváskérés bezárása\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cvisszahivas-keres-form id=\"$ctrl.id\" ng-show=\"$ctrl.showForm &amp;&amp; !$ctrl.success\" init-data=\"$ctrl.initData\" post-form=\"$ctrl.sendForm(data)\" errors=\"$ctrl.formError\" success=\"$ctrl.success\" document-url=\"{{$ctrl.documentUrl}}\"\u003E\u003C\u002Fvisszahivas-keres-form\u003E\u003Cdiv class=\"app-visszahivas-keres__success-wrap\" aria-live=\"assertive\"\u003E\u003Cdiv class=\"app-visszahivas-keres__success\" ng-if=\"$ctrl.success &amp;&amp; $ctrl.showForm\"\u003E\u003Cp class=\"app-visszahivas-keres__success-text\" tabindex=\"-1\"\u003EKöszönjük érdeklődését!\u003Cbr\u003EMunkatársunk hamarosan felveszi Önnel a kapcsolatot.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbutton class=\"button button--vhk\" ng-if=\"!$ctrl.showForm\" aria-expanded=\"{{$ctrl.showForm}}\" ng-click=\"$ctrl.showOrHideForm()\"\u003EKérjen visszahívást!\u003Cspan class=\"onyp-arrow_vhk\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fbutton\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ 626:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61), __webpack_require__(591)))

/***/ }),

/***/ 628:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(626);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61)))

/***/ })

},[563]);


// WEBPACK FOOTER //
// application/visszahivas-keres.bundle.js